import { createStyles } from '../../../../styles/helpers'

const useStyles = createStyles({
  quotationsProductsTable: {
    // workaround to have spacing between end of the screen and DatesSelector when it in the end of the screen
    paddingBottom: '240px'
  },
  chipsContainer: {
    display: 'flex',
    gap: '8px',
    marginTop: '8px'
  }
})

export default useStyles
